// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__rquDR","title":"FrontImage_title__2kk3Z"};